import React, {useContext} from "react";
import {useHistory} from 'react-router-dom'
import {SubNavBarContext} from "./SubNavBarContext";

export const SubNavBar = ({good}) => {
    const {selectedPage, setSelectedPage} = useContext(SubNavBarContext)
    const history = useHistory();
    const items = [
        {title: 'Main', link: '/admin' + good.link},
        {title: 'Overview', link: '/admin' + good.link + '/overview'},
        {title: 'Specs', link: '/admin' + good.link + '/specs'},
        {title: 'Buy', link: '/admin' + good.link + '/buy'}
    ]

    const clickHandler = (link) => {
        setSelectedPage(link)
        history.push(link)
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                    {items.map(item => (
                        <li key={item.link}
                            onClick={() => clickHandler(item.link)}
                            style={{fontSize: '1.5rem'}}
                            className={selectedPage === item.link ? 'nav-item active' : 'nav-item'}>
                            {item.title}
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    )
}